"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsMicrosoft_de_de = void 0;
function componentsMicrosoft_de_de() {
    return {
        "components.microsoftfiles.nofolderset": "Kein Ordner angegeben",
        "components.microsoftfiles.changefolder": "Ordner wechseln",
        "components.microsoftfiles.setfolder": "Ordner setzen",
        "components.microsoftfiles.openfolder": "Ordner öffnen",
        "components.microsoftfiles.removefolder": "Verlinkung aufheben",
        "components.microsoftfiles.dialogtitle": "Microsoft 365 Verzeichnis wählen",
        "components.microsoftfiles.directoryup": "Ebene höher",
        "components.microsoftfiles.nodrive": "Kein Sharepoint Verzeichnis verlinkt"
    };
}
exports.componentsMicrosoft_de_de = componentsMicrosoft_de_de;
